import React from "react";

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
  const [redundancyFlag, setRedundancyFlag] = React.useState(true);
  return (
    <AppContext.Provider value={{ redundancyFlag, setRedundancyFlag }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => React.useContext(AppContext);
